/**
 * @generated SignedSource<<e0baef87aa06daf0fb37165a0d1e8dc1>>
 * @relayHash 83adcc8ae6c212115ebb169a54566071
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83adcc8ae6c212115ebb169a54566071

import type { ConcreteRequest } from 'relay-runtime';
export type UnpinIssueCommentInput = {
  clientMutationId?: string | null | undefined;
  issueCommentId: string;
};
export type unpinCommentMutation$variables = {
  input: UnpinIssueCommentInput;
};
export type unpinCommentMutation$data = {
  readonly unpinIssueComment: {
    readonly clientMutationId: string | null | undefined;
    readonly issueComment: {
      readonly id: string;
      readonly isPinned: boolean | null | undefined;
      readonly issue: {
        readonly pinnedIssueComment: {
          readonly id: string;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
};
export type unpinCommentMutation$rawResponse = {
  readonly unpinIssueComment: {
    readonly clientMutationId: string | null | undefined;
    readonly issueComment: {
      readonly id: string;
      readonly isPinned: boolean | null | undefined;
      readonly issue: {
        readonly id: string;
        readonly pinnedIssueComment: {
          readonly id: string;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
};
export type unpinCommentMutation = {
  rawResponse: unpinCommentMutation$rawResponse;
  response: unpinCommentMutation$data;
  variables: unpinCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPinned",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PinnedIssueComment",
  "kind": "LinkedField",
  "name": "pinnedIssueComment",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unpinCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnpinIssueCommentPayload",
        "kind": "LinkedField",
        "name": "unpinIssueComment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "issueComment",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unpinCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnpinIssueCommentPayload",
        "kind": "LinkedField",
        "name": "unpinIssueComment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "issueComment",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "83adcc8ae6c212115ebb169a54566071",
    "metadata": {},
    "name": "unpinCommentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "70d07f82a4fe7a3cd582bc30b0d902a5";

export default node;
